import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import CookieConsent from "react-cookie-consent";

export default class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount(){
        //alert(JSON.stringify(this.props.history));
        //alert(JSON.stringify(process.env.PUBLIC_URL));
    }
    render(){
        const st={
            marginTop: '75px'
        }
        const stp={
            color: 'black',
            textIndent: '50px',
            textAlign: 'justify',
            textJustify: 'inter-word'
        }

        const sta={
            color: 'blue',
        }

        const stbold={
            marginLeft: '-50px',
            fontWeight: 'bold',
        }
        return (
        <div>
            <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
            <div className="carousel-inner">
                <div className="carousel-item active">
                <img className="d-block mx-auto img-fluid" src="https://vasileclaudiu.github.io/reactsopcast/assets/images/carousel/app-desktop.jpg" alt="Login Page"/>
                </div>
                <div className="carousel-item">
                <img className="d-block mx-auto img-fluid" src="https://vasileclaudiu.github.io/reactsopcast/assets/images/carousel/dashbord-tvjwpage-digi24.jpg" alt="Digi24 Page"/>
                </div>
                <div className="carousel-item">
                <img className="d-block mx-auto img-fluid" src="https://vasileclaudiu.github.io/reactsopcast/assets/images/carousel/dashbord-tvjwpage-digisport.jpg" alt="DigiSport Page"/>
                </div>
                <div className="carousel-item">
                <img className="d-block mx-auto img-fluid" src="https://vasileclaudiu.github.io/reactsopcast/assets/images/carousel/dashbord-tvjwpage-filme.jpg" alt="Filme Page"/>
                </div>
                <div className="carousel-item">
                <img className="d-block mx-auto img-fluid" src="https://vasileclaudiu.github.io/reactsopcast/assets/images/carousel/dashbord-tvjwpage-filme-gladiator.jpg" alt="Filme Gladiator Page"/>
                </div>
                <div className="carousel-item">
                <img className="d-block mx-auto img-fluid" src="https://vasileclaudiu.github.io/reactsopcast/assets/images/carousel/login.jpg" alt="Login Page"/>
                </div>
                <div className="carousel-item">
                <img className="d-block mx-auto img-fluid" src="https://vasileclaudiu.github.io/reactsopcast/assets/images/carousel/dashbord.jpg" alt="Dashbord Page"/>
                </div>
                <div className="carousel-item">
                <img className="d-block mx-auto img-fluid" src="https://vasileclaudiu.github.io/reactsopcast/assets/images/carousel/dashbord-chat.jpg" alt="Dashbord Chat Page"/>
                </div>
                <div className="carousel-item">
                <img className="d-block mx-auto img-fluid" src="https://vasileclaudiu.github.io/reactsopcast/assets/images/carousel/dashbord-tvpage.jpg" alt="Dashbord TV Page"/>
                </div>
            </div>
            <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="sr-only">Previous</span>
            </a>
            <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="sr-only">Next</span>
            </a>
            </div>
            <div className="container" style={st}>
                <p style={stp}>Va multumim pentru folosirea celor doua aplicatii - React Sopcast - versiunea web a aplicatiei si - Vb Sopcast aplicatia Windows desktop <a href="https://vasileclaudiu.github.io/reactsopcast/assets/apps/VbSopcast.zip" target="_blank" style={sta}>VbSopcast</a> pentru sistemele de operare Windows.</p>
                <p style={stp}>Ambele aplicatii se folosesc pentru vizionarea canalelor romanesti de Televiziune - 4 canale in versiunea demo(se va utiliza user-ul demo@gmail.com ,respectiv parola demo12 ) si peste 70 de canale in versiunea PRO</p>
                <p style={stp}>Ambele aplicatii folosesc si necesita instalarea in prealabil a aplicatiei Sopcast, care poate fi descarcata/ instalata de pe site-ul oficial <a href="http://www.sopcast.com" target="_blank" style={sta}>Sopcast</a></p>
                <p style={stp}>Pentru a folosi aplicatia Windows desktop pentru sistemele de operare Windows, dupa ce a fost instalat Sopcast, pentru Sopcast trebuie rulat un script cu dreptul de admin din "C:\Program Files (x86)\SopCast" acesta se gaseste in arhiva "Setari-Sopcast.zip" - <a href="https://vasileclaudiu.github.io/reactsopcast/assets/apps/Setari-Sopcast.zip" target="_blank" style={sta}>Setari-Sopcast.zip</a>.</p>
                <p style={stp}>Pentru a folosi aplicatia Web - React Sopcast - dupa ce a fost instalata aplicatia Sopcast trebuie folosit Internet Explorer sau pentru Google Chrome trebuie instalat IE TAb - o extensie a Google Chrome.</p>
                <p style={stp}>Pentru a folosi aplicatia Web - React Sopcast - si a viziona programele TV pe Android(pe telefoanele mobile) se va instala pe Android <a href="https://play.google.com/store/apps/details?id=com.devaward.soptohttp&hl=ro" target="_blank" style={sta}>Sopcast Android</a> si player-ul Kodi-versiunea pentru Android <a href="https://play.google.com/store/apps/details?id=org.xbmc.kodi&hl=ro" target="_blank" style={sta}>Kodi Android</a>.</p>
                <p style={stp}><strong>Ultimile update-uri ale aplicatiei permite vizionarea online a programelor/canalelor TV fara Sopcast precum si vizionarea unui numar mare de filme(<span style={stbold}>peste 200 de filme si canale TV,iar numarul acestora creste de la o zi la alta!!!</span>) direct online - prin player web modern ce permite si subtitrare - fara nici-o alta aplicatie!!! <span style={stbold}>Odata cu venirea lui 2021, au venit noi facilitati, vizionarea youtube fara reclame!!!</span></strong></p>
                <p style={stp}>Pentru a folosi cele doua aplicatii, pentru primi suport si a beneficia de toate facilitatile aplicatiilor, respectiv toate update-urile urmatoare, va rugam sa faceti o donatie de minim 5 Euro prin PayPal.</p>

                <div className="mx-auto" style={sta}>&copy; 2019 - React Sopcast</div>
            </div>
        <CookieConsent
            location="bottom"
            buttonText="Accept cookies!!"
            cookieName="myAwesomeCookieName2"
            style={{ background: "#2B373B" }}
            buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
            expires={150}
        >
            This website uses cookies to enhance the user experience.{" "}
        </CookieConsent>
        </div>
        );
    }
}